import {
    GETINVENTORYPURCHASEORDERSHOW,
    CREATEINVENTORYPURCHASEORDERSHOW,
    UPDATEINVENTORYPURCHASEORDERSHOW,
    DELETEINVENTORYPURCHASEORDERSHOW,
    GETINVENTORYPURCHASEORDER,
    CREATEINVENTORYPURCHASEORDER,
    UPDATEINVENTORYPURCHASEORDER,
    DELETEINVENTORYPURCHASEORDER,
    GETINVENTORYPURCHASESHOW,
    CREATEINVENTORYPURCHASESHOW,
    UPDATEINVENTORYPURCHASESHOW,
    DELETEINVENTORYPURCHASESHOW,
    GETINVENTORYITEMQTY,
    GETINVENTORYGENERATEBILLQTY,
    GETINVENTORYITEM,
    CREATEINVENTORYITEM,
    UPDATEINVENTORYITEM,
    DELETEINVENTORYITEM,
    GETINVENTORYITEMBILL,
    CREATEINVENTORYITEMBILL,
    UPDATEINVENTORYITEMBILL,
    DELETEINVENTORYITEMBILL,
    GETINVENTORYITEMBADSTOCK,
    CREATEINVENTORYITEMBADSTOCK,
    UPDATEINVENTORYITEMBADSTOCK,
    DELETEINVENTORYITEMBADSTOCK,
    GETINVENTORYGENERATEBILL,
    CREATEINVENTORYGENERATEBILL,
    UPDATEINVENTORYGENERATEBILL,
    DELETEINVENTORYGENERATEBILL,
    GETINVENTORYGENERATEBILLTRANSACTION,
    CREATEINVENTORYGENERATEBILLTRANSACTION,
    UPDATEINVENTORYGENERATEBILLTRANSACTION,
    DELETEINVENTORYGENERATEBILLTRANSACTION,
    CREATEHOSPITALEINVENTORYITEM,
    CREATEHOSPITALEINVENTORYITEMISSUE,
    CREATEHOSPITALEINVENTORYSTOCK,
    DELETEHOSPITALEINVENTORYITEM,
    DELETEHOSPITALEINVENTORYITEMISSUE,
    DELETEHOSPITALEINVENTORYSTOCK,
    GETHOSPITALEINVENTORYITEM,
    GETHOSPITALEINVENTORYITEMISSUE,
    GETHOSPITALEINVENTORYSTOCK,
    UPDATEHOSPITALEINVENTORYITEM,
    UPDATEHOSPITALEINVENTORYITEMISSUE,
    UPDATEHOSPITALEINVENTORYSTOCK,
    GETINVENTORYPURCHASEBILL,
    CREATEINVENTORYPURCHASEBILL,
    UPDATEINVENTORYPURCHASEBILL,
    DELETEINVENTORYPURCHASEBILL,
    GETINVENTORYPURCHASEBILLTRANSACTION,
    CREATEINVENTORYPURCHASEBILLTRANSACTION,
    UPDATEINVENTORYPURCHASEBILLTRANSACTION,
    DELETEINVENTORYPURCHASEBILLTRANSACTION,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEHOSPITALEINVENTORYITEM:
            return {
                ...state,
                inventoryitemSaveStatus: action.payload.success,
            }
        case GETHOSPITALEINVENTORYITEM:
            return {
                ...state,
                inventoryitemList: action.payload.data,
            }
        case UPDATEHOSPITALEINVENTORYITEM:
            return {
                ...state,
                inventoryitemUpdateStatus: action.payload.success,
            }

        case DELETEHOSPITALEINVENTORYITEM:
            return {
                ...state,
                inventoryitemDeleteStatus: action.payload.success,
            }
        case CREATEHOSPITALEINVENTORYSTOCK:
            return {
                ...state,
                inventorystockSaveStatus: action.payload.success,
            }
        case GETHOSPITALEINVENTORYSTOCK:
            return {
                ...state,
                inventorystockList: action.payload.data,
            }
        case UPDATEHOSPITALEINVENTORYSTOCK:
            return {
                ...state,
                inventorystockUpdateStatus: action.payload.success,
            }

        case DELETEHOSPITALEINVENTORYSTOCK:
            return {
                ...state,
                inventorystockDeleteStatus: action.payload.success,
            }
        case CREATEHOSPITALEINVENTORYITEMISSUE:
            return { ...state, inventoryitemissueSaveStatus: action.payload.success, }
        case GETHOSPITALEINVENTORYITEMISSUE:
            return { ...state, inventoryitemissueList: action.payload.data, }
        case UPDATEHOSPITALEINVENTORYITEMISSUE:
            return { ...state, inventoryitemissueUpdateStatus: action.payload.success, }
        case DELETEHOSPITALEINVENTORYITEMISSUE:
            return { ...state, inventoryitemissueDeleteStatus: action.payload.success, }

        case CREATEINVENTORYPURCHASEBILL:
            return { ...state, InventoryItemPurchaseBillSaveStatus: action.payload.success, }
        case GETINVENTORYPURCHASEBILL:
            return { ...state, InventoryItemPurchaseBillList: action.payload.data, }
        case UPDATEINVENTORYPURCHASEBILL:
            return { ...state, InventoryItemPurchaseBillUpdateStatus: action.payload.success, }
        case DELETEINVENTORYPURCHASEBILL:
            return { ...state, InventoryItemPurchaseBillDeleteStatus: action.payload.success, }
        case CREATEINVENTORYPURCHASEBILLTRANSACTION:
            return { ...state, InventoryPurchaseBillTransactionSaveStatus: action.payload.success, }
        case GETINVENTORYPURCHASEBILLTRANSACTION:
            return { ...state, InventoryPurchaseBillTransactionList: action.payload.data, }
        case UPDATEINVENTORYPURCHASEBILLTRANSACTION:
            return { ...state, InventoryPurchaseBillTransactionUpdateStatus: action.payload.success, }
        case DELETEINVENTORYPURCHASEBILLTRANSACTION:
            return { ...state, InventoryPurchaseBillTransactionDeleteStatus: action.payload.success, }
        case GETINVENTORYITEM:
            return { ...state, InventoryItemPurchaseList: action.payload.data, }
        case GETINVENTORYITEMQTY:
            return { ...state, InventoryItemQTYList: action.payload.data, }
        case CREATEINVENTORYITEM:
            return { ...state, InventoryItemSaveStatus: action.payload.success, }
        case UPDATEINVENTORYITEM:
            return { ...state, InventoryItemUpdateStatus: action.payload.success, }
        case DELETEINVENTORYITEM:
            return { ...state, InventoryItemDeleteStatus: action.payload.success, }
        case GETINVENTORYITEMBILL:
            return { ...state, InventoryItemBillList: action.payload.data, }
        case CREATEINVENTORYITEMBILL:
            return { ...state, InventoryItemBillSaveStatus: action.payload.success, }
        case UPDATEINVENTORYITEMBILL:
            return { ...state, InventoryItemBillUpdateStatus: action.payload.success, }
        case DELETEINVENTORYITEMBILL:
            return { ...state, InventoryItemBillDeleteStatus: action.payload.success, }
        case GETINVENTORYITEMBADSTOCK:
            return { ...state, InventoryItemBadStockList: action.payload.data, }
        case CREATEINVENTORYITEMBADSTOCK:
            return { ...state, InventoryItemBadStockSaveStatus: action.payload.success, }
        case UPDATEINVENTORYITEMBADSTOCK:
            return { ...state, InventoryItemBadStockUpdateStatus: action.payload.success, }
        case DELETEINVENTORYITEMBADSTOCK:
            return { ...state, InventoryItemBadStockDeleteStatus: action.payload.success, }
        case GETINVENTORYGENERATEBILL:
            return { ...state, InventoryItemGenerateBillList: action.payload.data, }
        case GETINVENTORYGENERATEBILLQTY:
            return { ...state, InventoryItemGenerateBillQTYList: action.payload.data, }
        case CREATEINVENTORYGENERATEBILL:
            return { ...state, InventoryItemGenerateBillSaveStatus: action.payload.success, }
        case UPDATEINVENTORYGENERATEBILL:
            return { ...state, InventoryItemGenerateBillUpdateStatus: action.payload.success, }
        case DELETEINVENTORYGENERATEBILL:
            return { ...state, InventoryItemGenerateBillDeleteStatus: action.payload.success, }
        case GETINVENTORYGENERATEBILLTRANSACTION:
            return { ...state, InventorygenerateBillTransactionList: action.payload.data, }
        case CREATEINVENTORYGENERATEBILLTRANSACTION:
            return { ...state, InventorygenerateBillTransactionSaveStatus: action.payload.success, }
        case UPDATEINVENTORYGENERATEBILLTRANSACTION:
            return { ...state, InventorygenerateBillTransactionUpdateStatus: action.payload.success, }
        case DELETEINVENTORYGENERATEBILLTRANSACTION:
            return { ...state, InventorygenerateBillTransactionDeleteStatus: action.payload.success, }
        case GETINVENTORYPURCHASESHOW:
            return { ...state, InventoryPurchaseShowList: action.payload.data, }
        case CREATEINVENTORYPURCHASESHOW:
            return { ...state, InventoryPurchaseShowSaveStatus: action.payload.success, }
        case UPDATEINVENTORYPURCHASESHOW:
            return { ...state, InventoryPurchaseShowUpdateStatus: action.payload.success, }
        case DELETEINVENTORYPURCHASESHOW:
            return { ...state, InventoryPurchaseShowDeleteStatus: action.payload.success, }
        case GETINVENTORYPURCHASEORDER:
            return { ...state, InventoryPurchaseOrderList: action.payload.data, }
        case CREATEINVENTORYPURCHASEORDER:
            return { ...state, InventoryPurchaseOrderSaveStatus: action.payload.success, }
        case UPDATEINVENTORYPURCHASEORDER:
            return { ...state, InventoryPurchaseOrderUpdateStatus: action.payload.success, }
        case DELETEINVENTORYPURCHASEORDER:
            return { ...state, InventoryPurchaseOrderDeleteStatus: action.payload.success, }
        case GETINVENTORYPURCHASEORDERSHOW:
            return { ...state, InventoryPurchaseOrderShowList: action.payload.data, }
        case CREATEINVENTORYPURCHASEORDERSHOW:
            return { ...state, InventoryPurchaseOrderShowSaveStatus: action.payload.success, }
        case UPDATEINVENTORYPURCHASEORDERSHOW:
            return { ...state, InventoryPurchaseOrderShowUpdateStatus: action.payload.success, }
        case DELETEINVENTORYPURCHASEORDERSHOW:
            return { ...state, InventoryPurchaseOrderShowDeleteStatus: action.payload.success, }

        default:
            return state
    }
}